// "Où l'utiliser" — maps a subsidy universe to its in-app destination. The pills double as the
// call-to-action, so each actionable universe links to where the subsidy is actually spent.
// Routes are the literal landing paths (kept in sync with the owning features):
//   /remboursements  → refunds  (REFUNDS_PATH, src/features/refunds/routes.tsx)
//   /boutique        → shop     (SHOP_PATH, src/features/boutique/index-cms/router.tsx — NOT the
//                                /boutique/catalogue redirect)
//   /bon-plans       → deals    (DEALS_PATH, src/features/deals/routes.tsx)
//   /catalogue       → rentals  (RENTALS_PATH, src/features/rentals/routes.tsx — gated by the
//                                service_catalog feature)
//   /boutique/camping → campings (CAMPING_PATH, src/features/boutique/routes.tsx — gated by the
//                                 catalog_campings plan feature)
// The map keys ("Remboursements", "Locations", "Campings", …) are the universe label strings
// SummaryAdapter::UNIVERSE_LABELS emits in yeati-api; they are the backend/frontend join key, so
// any rename must change both repos together (an unmatched key renders an icon-less, link-less pill).

export const NO_UNIVERSE = "Sans univers";

export const UNIVERSE_ICON: Record<string, string> = {
  "Remboursements": "💸",
  "Bons Plans": "🏷️",
  "Boutique Yeati": "🛍️",
  "Locations": "🏠",
  "Campings": "⛺",
};

export type UniverseAction = { label: string, to: string };

export const USE_ACTIONS: Record<string, UniverseAction> = {
  "Remboursements": { label: "Faire une demande de remboursement", to: "/remboursements" },
  "Boutique Yeati": { label: "Utiliser en Boutique Yeati", to: "/boutique" },
  "Bons Plans": { label: "Voir les Bons Plans", to: "/bon-plans" },
  "Locations": { label: "Voir les Locations", to: "/catalogue" },
  "Campings": { label: "Voir les Campings", to: "/boutique/camping" },
};

export const universeIcon = (universe: string): string | undefined => UNIVERSE_ICON[universe];
